const urls = {
  index: "/images",
} as const;

export default urls;
